import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CnpjUtils } from '../utils/cnpj.utils';

export class CnpjAlfanumericoValidator {
  static validar(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const normalized = CnpjUtils.normalizar(value);
      if (normalized.length !== 14) {
        return { cnpjTamanho: { message: 'CNPJ deve conter exatamente 14 caracteres' } };
      }
      const primeiros12 = normalized.substring(0, 12);
      if (!/^[0-9A-Z]{12}$/.test(primeiros12)) {
        return { cnpjFormato12: { message: 'Os primeiros 12 caracteres devem ser alfanuméricos' } };
      }
      const ultimos2 = normalized.substring(12, 14);
      if (!/^[0-9]{2}$/.test(ultimos2)) {
        return { cnpjDigitosVerificadores: { message: 'Os últimos 2 caracteres devem ser números' } };
      }
      if (!CnpjUtils.validarDigitos(normalized)) {
        return { cnpjDigito: { message: 'Dígitos verificadores inválidos' } };
      }
      return null;
    };
  }
}
